import { Component } from '@angular/core';

@Component({
    selector: 'self-ins-rolling',
    templateUrl: './rolling-page.component.html',
    styleUrls: ['./rolling-page.component.scss']
})
export class RollingPageComponent {}
